import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    blue: {
      main: 'rgba(192, 211, 218, 1)',
      light: 'rgba(232, 239, 242, 1)',
      dark: 'rgba(0, 49, 68, 1)',
      text: 'rgba(1, 77, 108, 1)',
      placeholder: 'rgba(94, 125, 137, 1)',
      button: 'rgba(75, 186, 197, 1)',
    },
    white: {
      main: '#fff',
    },
    black: {
      dark: '#000',
      text: 'rgba(0, 22, 31, 1)',
      semiDark: 'rgba(18, 22, 25, 1)',
    },
    red: {
      main: 'rgba(225, 45, 45, 1)',
      semiRed: 'rgba(250, 219, 219, 1)',
      dark: 'rgba(178, 97, 26, 1)',
      semiOrange: 'rgba(247, 220, 197, 1)',
      semiRed: 'rgba(251, 239, 228, 1)',
    },
    yellow: {
      main: 'rgba(255, 250, 153, 1)',
    },
    green: {
      main: 'rgba(1, 77, 108, 1)', // Original
      light: 'rgba(51, 127, 158, 1)', // Lightened
      dark: 'rgba(21, 147, 105, 1)',
      shine: 'rgba(224, 251, 242, 1)',
    },
  },
  typography: (palette) => ({
    fontFamily: 'Heebo',

    h1: {
      fontSize: 'clamp(20px, 3vw, 40px)',
      fontWeight: 700,
      lineHeight: 1,
      color: palette.black.text,
    },
    h2: {
      fontSize: 'clamp(16px, 3vw, 32px)',
      fontWeight: 700,
      lineHeight: 1,
    },
    h3: {
      fontSize: 'clamp(16px, 2vw, 24px)',
      fontWeight: 600,
      lineHeight: 1,
    },
    mediumText: {
      fontSize: '20px',
      fontWeight: 500,
      lineHeight: 1,
      color: palette.blue.dark,
    },
    runningText: {
      fontWeight: 700,
      lineHeight: 1.25,
      color: palette.blue.dark,
    },
  }),
  components: {
    MuiDrawer: {
      styleOverrides: {
        root: {
          '.MuiPaper-root': {
            display: 'block',

            '.muirtl-1r9jet7': {
              flexDirection: 'column',
              alignItems: 'flex-start',
              padding: 'unset',
            },

            '.MuiList-root': {
              paddingTop: '11px',
              paddingBottom: '43px',
              display: 'flex',
              flexDirection: 'column',
              rowGap: '24px',

              '.MuiListItemIcon-root': {
                marginRight: 'unset',
                paddingInline: '11px',
              },
            },

            '.bell': {
              padding: '19px 24px',
              '.MuiButtonBase-root': {
                padding: '8px',
                justifyContent: 'flex-start',
              },
            },

            '.avatar': {
              padding: '14px',
              //   '.MuiButtonBase-root': {
              // justifyContent: 'flex-start',
              // padding: '8px',
              //   },
            },
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          maxWidth: 'unset !important',
          width: 'min(1681px, 87%) !important',
          padding: 'unset !important',
          margin: 'unset',
          marginTop: '80px',
          marginBottom: '97px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          padding: '12px 32px',
          fontSize: '16px',
          fontWeight: '700',
          transition: 'all 0.4s ease',
        },
      },
      variants: [
        {
          props: { variant: 'main' },
          style: ({ theme }) => ({
            background: theme.palette.blue.button,
            color: theme.palette.white.main,
            border: '1px solid rgba(1, 80, 110, 1)',

            '&:hover': {
              backgroundImage:
                'linear-gradient(90deg, #014D6C 0%, #014D6C 6.25%, #014E6D 12.5%, #01506E 18.75%, #015270 25%, #025573 31.25%, #025975 37.5%, #025D79 43.75%, #03627D 50%, #036781 56.25%, #046D86 62.5%, #04748C 68.75%, #057C92 75%, #068498 81.25%, #068D9F 87.5%, #0796A7 93.75%, #08A0AF 100%)',
              backgroundColor: 'transparent',
            },
          }),
        },
        {
          props: { variant: 'containedWhite' },
          style: ({ theme }) => ({
            backgroundColor: theme.palette.white.main,
            color: theme.palette.blue.main,
            border: `1px solid ${theme.palette.blue.main}`,
          }),
        },
        {
          props: { variant: 'containedBlack' },
          style: ({ theme }) => ({
            backgroundColor: 'rgb(55, 56, 56)',
            color: theme.palette.white.main,
            padding: '10px 15px',

            '&:hover': {
              backgroundColor: 'rgb(55, 56, 56)',
            },
          }),
        },
        {
          props: { variant: 'borderWhite' },
          style: ({ theme }) => ({
            border: `1px solid ${theme.palette.white.main}`,
            color: theme.palette.white.main,
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: 700,

            '&:hover': {
              backgroundColor: theme.palette.blue.dark,
              color: theme.palette.white.main,
            },
          }),
        },
        {
          props: { variant: 'borderBlue' },
          style: ({ theme }) => ({
            border: `1px solid ${theme.palette.blue.text}`,
            color: theme.palette.blue.text,
            padding: '12px 32px',
            fontSize: '16px',
            fontWeight: 700,

            '&:hover': {
              backgroundColor: theme.palette.blue.dark,
              color: theme.palette.white.main,
            },
          }),
        },
      ],
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '1.3rem', // Adjust the font size
          color: 'rgba(1, 77, 108, 1)', // Default color
          '&.Mui-selected': {
            color: 'rgba(1, 77, 108, 1)', // Selected color
          },
        },
      },
    },
  },
});

export default theme;
